import Icon from 'veui/components/Icon'
import { IconTimesCircle } from 'dls-icons-vue'

Icon.register('times-circle', IconTimesCircle)
